import React, { useState } from "react";
import View from "./View";
import AudioTextFilePlayer from "components/audioPlayer/PDFPlayer/AudioTextFilePlayer";
import { Stack } from "@mui/material";
import PdfSelector from "components/experimental/PdfSelector";
import AudioTextFileList from "components/audioPlayer/PDFPlayer/AudioTextFileList";
import { useSelector } from "react-redux";
import BackgroundAudioPlayer from "components/audioPlayer/BackgroundAudioPlayer";

export default function AudioView() {

  const [audioTextFileId, setAudioTextFileId] = useState(null);

  return (
    <View>
      <Stack
        alignItems="center"
        sx={{
          width: "100%",
        }}
        spacing={1}
      >
        <BackgroundAudioPlayer />
        <AudioTextFileList
          onSelectFile={setAudioTextFileId} 
        />
        <PdfSelector 
          onCreated={setAudioTextFileId}
        />

        <AudioTextFilePlayer 
          audioTextFileId={audioTextFileId}
        />
        
        {/* <AudioTracker />
        <AudioPageLoader />
        <AudioPageFetcher />
        <AudioTextFilePlayer /> */}
      </Stack>
    </View>
  );
}
